<div class="block-ui-template">
  <img src="assets/images/loading_JUL.svg" alt="" width="180px">
</div>
